import { GuidedCreation } from "../guided-creation/guided.creation.bean"

export class GuidedCreation2
{
    organization   ?: GuidedOrganization
	sites           : GuidedSite[]
	devices        ?: GuidedDevice
    operator       ?: GuidedOperator
    
    numCodino      ?: number
    numSummary     ?: number
    numCounter     ?: number
    numService     ?: number
    numOperator    ?: number

    public static fromGuidedCreation( old: GuidedCreation ): GuidedCreation2
    {
        let _new: GuidedCreation2 = {
            organization    :   GuidedOrganization  .fromGuidedCreation( old )  ,
            sites           :   GuidedSite          .fromGuidedCreation( old )  ,
            devices         :   GuidedDevice        .fromGuidedCreation( old )  ,
            operator        :   GuidedOperator      .fromGuidedCreation( old )
        }
        return _new;
    } 
}

export class GuidedOrganization {
    pharmaType  : number
    vat         : string
    name        : string
    placeId     : number
    zipCode     : string
    address     : string
    email       : string
    phone       : string
    enabled    ?: number

    public static fromGuidedCreation ? ( old: GuidedCreation ): GuidedOrganization
    {
        const _org = {
            pharmaType  : old.pharma,
            vat         : old.organization?.vatRegistration ? old.organization.vatRegistration.toString() : null,
            name        : old.organization?.name     ,
            placeId     : old.organization?.placeId  ,
            zipCode     : old.organization?.zipCode  ,
            address     : old.organization?.address  ,
            email       : old.organization?.email    ,
            phone       : old.organization?.phone    ,
        }

        return _org
    } 

}

export class GuidedSite     {
    code        ?: string
    name         : string
    placeId     ?: number
    zipCode     ?: string
    address     ?: string
    email       ?: string
    phone       ?: string
    latitude     : number
    longitude    : number
    enabled     ?: number
    services     : GuidedService[]


    public static fromGuidedCreation ? ( old: GuidedCreation ): GuidedSite[]
    {
        const _site: GuidedSite = {
            name         : old.organization?.name,
            placeId      : old.organization?.placeId,
            zipCode      : old.organization?.zipCode,
            address      : old.organization?.address,
            email        : old.organization?.email,
            latitude     : old.organization?.latitude,
            longitude    : old.organization?.longitude,

            services     : GuidedService.fromGuidedCreation( old )
        }

        return [ _site ] 
    } 
}

export class GuidedService  {
    
    name             : string
	ticketPrefix    ?: string
	booking          : number
    bookPrefix      ?: string
    stimaOrario     ?: number
    
    public static fromGuidedCreation ? ( old: GuidedCreation ): GuidedService[]
    {
        const _services: GuidedService[] = []
        if ( old.service.name1 ) 
            _services.push( this.create ( old.service.name1, old ) )
        if ( old.service.name2 ) 
            _services.push( this.create ( old.service.name2, old ) )
        if ( old.service.name3 ) 
            _services.push( this.create ( old.service.name3, old ) )
        if ( old.service.name4 ) 
            _services.push( this.create ( old.service.name4, old ) )
        if ( old.service.name5 ) 
            _services.push( this.create ( old.service.name5, old ) )
        if ( old.service.name6 ) 
            _services.push( this.create ( old.service.name6, old ) )

        _services.forEach( service => service.stimaOrario = old.stima == "Y" ? 1 : 0 )
        
        return _services
    } 

    public static create ? ( name: string, old: GuidedCreation ): GuidedService
    {
        const _service = {
            name         : name,
            booking      : old.service.booking
        }

        return _service
    } 


}

export class GuidedDevice   {
    speechMessage   ?: string
    speechCounter   ?: string
    codinoName      ?: string
    counterName     ?: string
    summaryName     ?: string
    counterPolling  ?: number
    summaryPolling  ?: number
    summaryTitle    ?: string

    public static fromGuidedCreation ? ( old: GuidedCreation ): GuidedDevice
    {

        const _device = {
            summaryTitle    :   old.customName,
        }

        return _device
    } 

}

export class GuidedOperator{
    name         : string
    password    ?: string
    forced      ?: number

    public static fromGuidedCreation ? ( old: GuidedCreation ): GuidedOperator
    {
        const _operator = {
            name         : old.operatorName,
        }

        return _operator
    } 

}